// src/styles/SearchStyles.js
import styled from 'styled-components';

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const ContentContainer = styled.div`
  flex: 1;
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
`;

export const SearchForm = styled.form`
  margin-bottom: 2rem;
`;

export const SearchBox = styled.div`
  display: flex;
  margin-bottom: 0.5rem;
  width: 100%;
`;

export const SearchInput = styled.input`
  flex: 1;
  padding: 0.75rem 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  margin-right: 0.5rem;
  
  &:focus {
    outline: none;
    border-color: #3498db;
    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
  }
`;

export const SearchButton = styled.button`
  padding: 0.75rem 1.5rem;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  margin-right: 0.5rem;
  
  &:hover {
    background-color: #2980b9;
  }
  
  &:disabled {
    background-color: #95a5a6;
    cursor: not-allowed;
  }
`;

export const HelpText = styled.div`
  font-size: 0.9rem;
  color: #7f8c8d;
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`;

export const HintRow = styled.div`
  display: grid;
  grid-template-columns: 4rem 1fr;
  gap: 0.5rem;
  align-items: baseline;
`;

export const FieldChip = styled.code`
  display: inline-block;
  background: #eef1f4;
  color: #34495e;
  padding: 0.1rem 0.4rem;
  border-radius: 3px;
  font-size: 0.8rem;
  margin: 0 0.15rem 0.15rem 0;
`;

export const Note = styled.span`
  color: #b0b8c1;
  font-size: 0.78rem;
  margin-left: 0.5rem;
`;

export const ResultsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
`;

export const NoResults = styled.div`
  padding: 2rem;
  text-align: center;
  color: #7f8c8d;
  background-color: #f9f9f9;
  border-radius: 4px;
  border: 1px solid #ecf0f1;
`;

export const StatusChip = styled.span`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.8rem;
  font-weight: 500;
  background-color: ${props => {
    switch (props.status) {
      case 'complete':
        return '#2ecc71';
      case 'in_progress':
        return '#3498db';
      case 'failed':
        return '#e74c3c';
      case 'queued':
        return '#f39c12';
      default:
        return '#95a5a6';
    }
  }};
  color: white;
`;

export const IconImage = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  object-fit: contain;
`;

export const FormPanel = styled.div`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.25rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem 1.5rem;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;

  label {
    font-size: 0.8rem;
    font-weight: 600;
    color: #374151;
  }

  input {
    padding: 0.45rem 0.6rem;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    font-size: 0.875rem;

    &:focus {
      outline: none;
      border-color: #3498db;
      box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
    }
  }
`;
